import React, { useEffect, useRef } from 'react'

// Vídeo que no descarga nada hasta acercarse a pantalla y se pausa al salir de ella
function LazyVideo({ src, className }) {
    const ref = useRef(null);

    useEffect(() => {
        const video = ref.current;
        if (!video) return;

        const io = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                if (!video.getAttribute('src')) video.setAttribute('src', src);
                video.play().catch(() => {});
            } else {
                video.pause();
            }
        }, { rootMargin: '200px 0px' });

        io.observe(video);
        return () => io.disconnect();
    }, [src]);

    return <video ref={ref} loop muted playsInline preload="none" className={className} />;
}

export default LazyVideo
